import React from "react";
import { Provider } from 'react-redux';
import store from "./redux/store";
import { MerchantSelector } from "./modules/merchantSelector";
var App = function () {
    return (React.createElement(Provider, { store: store },
        React.createElement("div", { className: "App" },
            React.createElement("header", { className: "App-header" },
                React.createElement("h1", null, "Welcome to My React App"),
                React.createElement("p", null,
                    "Edit ",
                    React.createElement("code", null, "App.tsx"),
                    " and save to reload."),
                React.createElement(MerchantSelector, null)))));
};
export default App;
//# sourceMappingURL=App.js.map